<div class="counter-list">
  <div class="counter-list__rows">
    @for (row of rows(); track row.key) {
      <div class="counter-list__row" [class.counter-list__row--active]="count(row.key) > 0">
        <span class="counter-list__label">{{ row.custom ? row.label : (row.label | translate) }}</span>
        <span class="counter-list__controls">
          <button
            type="button"
            class="counter-list__button"
            [attr.aria-label]="
              ('NumberStepper.decrease' | translate) +
              ': ' +
              (row.custom ? row.label : (row.label | translate))
            "
            [disabled]="disabled() || count(row.key) === 0"
            (click)="change(row.key, -1)"
          >
            <span class="material-icons" aria-hidden="true">remove</span>
          </button>
          <span class="counter-list__count" aria-live="polite">{{ count(row.key) }}</span>
          <button
            type="button"
            class="counter-list__button"
            [attr.aria-label]="
              ('NumberStepper.increase' | translate) +
              ': ' +
              (row.custom ? row.label : (row.label | translate))
            "
            [disabled]="!canIncrease(row.key)"
            (click)="change(row.key, 1)"
          >
            <span class="material-icons" aria-hidden="true">add</span>
          </button>
        </span>
      </div>
    }
  </div>

  @if (allowCustom()) {
    @if (editingCustom()) {
      <span class="counter-list__custom">
        <input
          #customInput
          type="text"
          class="counter-list__custom-input"
          [placeholder]="customPlaceholder() | translate"
          [maxLength]="customMaxLength()"
          (keydown.enter)="$event.preventDefault(); confirmCustom()"
          (keydown.escape)="cancelCustom()"
        />
        <button type="button" class="counter-list__add counter-list__add--confirm" (click)="confirmCustom()">
          {{ 'ChipSelect.confirm' | translate }}
        </button>
      </span>
    } @else {
      <button type="button" class="counter-list__add" [disabled]="disabled()" (click)="startCustom()">
        {{ customLabel() | translate }}
      </button>
    }
  }
</div>
